import React from "react";
import { OrderType } from "../../enums";
import { useOrder } from "../../contexts/order";

function AddOrderComponent() {
  const [, { setFormState }] = useOrder();

  function handleClick(type = 0) {
    setFormState({ type: type, editId: null });
  }
  return (
    <div>
      <div className="mt-3 py-10">
        <div className="flex gap-4 justify-center ">
          <button
            onClick={() => handleClick(OrderType.Barcode)}
            className="bg-gray-500 text-white p-2 rounded-md"
          >
            Barcode
          </button>
          <button
            onClick={() => handleClick(OrderType.Color)}
            className="bg-gray-500 text-white p-2 rounded-md"
          >
            Color
          </button>
          <button
            onClick={() => handleClick(OrderType.Paper)}
            className="bg-gray-500 text-white p-2 rounded-md"
          >
            Paper
          </button>
          <button
            onClick={() => handleClick(OrderType.Sheet)}
            className="bg-gray-500 text-white p-2 rounded-md"
          >
            Sheet
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddOrderComponent;
